import React, { Component } from "react";

import PortfolioColumn from "./PortfolioColumn";
import PortfolioImage from "./PortfolioImage";
import Modal from "./Modal";

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        activeImage: 0
      }
    };
    this.openGallery = this.openGallery.bind(this);
    this.previousImage = this.previousImage.bind(this);
    this.nextImage = this.nextImage.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  openGallery(clickedImage) {
    this.setState({
      modal: {
        activeImage: clickedImage
      }
    });
  }

  handleKeyPress(event) {
    if (event.key === "ArrowRight") {
      this.nextImage();
    } else if (event.key === "ArrowLeft") {
      this.previousImage();
    }
  }

  nextImage() {
    var nextIndex = this.state.modal.activeImage + 1;

    if (nextIndex < this.props.imageList.length) {
      this.setState({
        modal: {
          activeImage: nextIndex
        }
      });
    }
  }

  previousImage() {
    var prevIndex = this.state.modal.activeImage;
    if (prevIndex > 0) {
      prevIndex--;
      this.setState({
        modal: { activeImage: prevIndex }
      });
    }
  }

  render() {
    var multiplier = this.props.imageList.length / 3;
    var columnA = this.props.imageList.slice(0, multiplier);
    var columnB = this.props.imageList.slice(multiplier, multiplier * 2);
    var columnC = this.props.imageList.slice(multiplier * 2, multiplier * 3);

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row portfolio">
            <PortfolioColumn
              imageList={columnA}
              openGallery={this.openGallery}
            />
            <PortfolioColumn
              imageList={columnB}
              openGallery={this.openGallery}
            />
            <PortfolioColumn
              imageList={columnC}
              openGallery={this.openGallery}
            />
          </div>
        </div>
        <Modal id="myModal" handleKeyPress={this.handleKeyPress}>
          <PortfolioImage
            currentImage={this.props.imageList[this.state.modal.activeImage]}
            nextImage={this.nextImage}
            prevImage={this.previousImage}
            imageMax={this.props.imageList.length - 1}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery.js